import { Injectable } from '@angular/core';
import * as ProgramListActions from '@carm/_configs/store/actions/program-list.actions';
import * as ProgramListStore from '@carm/_configs/store/reducers/program-list.reducer';
import * as ProgramListSelectors from '@carm/_configs/store/selectors/progam-list.selectors';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';


@Injectable()
export class ProgramFacadeService {
  constructor(
    protected store: Store<ProgramListStore.ProgramsListState>,
  ) {}

  getInactivePrograms(): Observable<string[]> {
    return this.store.pipe(
      select(ProgramListSelectors.getInactivePrograms)
    );
  }

  loadInactivePrograms(): boolean {
    this.store.dispatch(
      ProgramListActions.loadInactivePrograms()
    );
    return true;
  }

}
